import { Component, ViewChild } from '@angular/core';
import { UserPrivilegeService } from 'src/app/services/user-privilege.service';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { UserService } from 'src/app/services/user.service';
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Router ,ActivatedRoute} from '@angular/router';
import {SettingsService} from 'src/app/services/settings.service'
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { TripService } from 'src/app/services/trip.service';
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';

export interface TripData {
  tripDuration: string;
  tripName: string;
  tripID: string;
}

const TRIP_DATA: TripData[] = [
  // { tripDuration: 'N/A', tripName: 'Test trip Personal', tripID: 'TRS000PD5JR' },
  // { tripDuration: '10-Aug-10-Aug', tripName: 'Test Trip', tripID: 'TRS000PD4YV' },
  // { tripDuration: 'N/A', tripName: 'Test trip Personal', tripID: 'TRS000PD3WP' },
  // { tripDuration: '25-Aug-25-Aug', tripName: 'Test Trip', tripID: 'TRS000PD2PH' },
  // { tripDuration: 'N/A', tripName: 'Test trip Personal', tripID: 'TRS000PD1JR' },
  // { tripDuration: '15-Aug-15-Aug', tripName: 'Test Trip', tripID: 'TRS000PD03Q' },
  // { tripDuration: 'N/A', tripName: 'Test trip Personal', tripID: 'TRS000PCZ94' },
  // { tripDuration: '02-Sep-02-Sep', tripName: 'Test Trip 23 July', tripID: 'TRS000PCYPK' },
  // { tripDuration: 'N/A', tripName: 'Test trip Personal', tripID: 'TRS000PCXPT' },
  // { tripDuration: '10-Sep-10-Sep', tripName: 'Test Trip', tripID: 'TRS000PCW3C' },
];
@Component({
  selector: 'app-trip',
  templateUrl: './trip.component.html',
  styleUrls: ['./trip.component.css']
})
export class TripComponent {

  constructor(private userInfoService:UserInfoService,private TripService:TripService,private toastMsgService:ToastmsgService,private route:ActivatedRoute,private SettingsService:SettingsService,private userService:UserService,private router:Router){
    this.tripRequest.userUid=this.userInfoService.getUserUuid();
    this.tripRequest.createdBy=this.userInfoService.getUserUuid()

    this.getActiveTripList()
    this.getTripList()
    this.ApprovalInitiatedList()

  }
  
  userInformation:any
  email:any
  ngOnInit(): void  {
  
    this.dataSource.paginator = this.paginator;


    this.route.queryParams.subscribe(params => {
    let data:any
    data=params
    this.email=this.userInfoService.getUsername();
   // for(let i=0 ;i <data.length; i++){ this.email +=data[i]; }
    this.getUserData();
  
   //this.userDataFields();
    
  
      });
      
     
  }
  tripRequest:any={
    "tripName":"",
    "tripDescription": "",
    "tripFor": "",
    "tripPurpose": "",
  }
  tripDisabled:boolean=false
 createTrip() {
   this.tripDisabled=true
    this.TripService
    .saveTrip(this.tripRequest)
    .subscribe({
      next : (res:any) => {
        this.tripDisabled=false
  this. tripRequest={
    "tripName":"",
    "tripDescription": "",
    "tripFor": "",
    "tripPurpose": "",
  }

  this.tripRequest.userUid=this.userInfoService.getUserUuid();
    this.tripRequest.createdBy=this.userInfoService.getUserUuid()

        this.toastMsgService.setMsg({msg : "Success!",msgTitle : "Success", msgType : "I"});
      //  location.reload()
      this.tripDisabled=false
      this.showAddNew=false
        if(res) {
       let data=res
       
        } else {
        
        } 
        this.getTripList()
      },error : (err) => {
        this.tripDisabled=false

        this.toastMsgService.setMsg({msg : "Failed",msgTitle : "Warning", msgType : "W"});
  
      }
    }
  )
  
    // Logic for trip creation goes here.
  }
  

  activeList(item:any){
    let request:any={
      activeTripUid:item?.tripUid,
      userUid:item?.userUid,
      // mode:'ACTIVE'
    }
    this.TripService
    .activeTrip(request)
    .subscribe({
      next : (res:any) => {
        this.router.navigate(["/app/trip-summary"]);

        // if(res) {
        //   const data = res

        //  } else {

        //  } 
      },error : (err) => {
        this.toastMsgService.setMsg({msg : "Failed to Manage Trip!",msgTitle : "Warning", msgType : "W"});

        // console.error("Error in fetching all getRoleList");
      }
    }
  )
  }
  tripStatus:any=''
  refreshStatus(item:any){
this.tripStatus=item
this.getTripList()
  }
    getTripList(){
      this.TripService
      .getTripList(this.tripRequest.userUid,this.tripStatus)
      .subscribe({
        next : (res:any) => {
          if(res) {
            const data = res

           this.dataSource = new MatTableDataSource(data);

           } else {
  
           } 
        },error : (err) => {
  
          console.error("Error in fetching all getRoleList");
        }
      }
    )
    }

    tripApprovalStatus:any=''
    refreshApprovalStatus(item:any){
  this.tripApprovalStatus=item
  this.ApprovalInitiatedList()}
    ApprovalInitiatedList(){
      this.TripService
      .getApprovalInitiatedList(this.tripRequest.userUid,this.tripApprovalStatus)
      .subscribe({
        next : (res:any) => {
          if(res) {
            console.log(res)
            const data = res
           this.ApprovalSource = new MatTableDataSource(data);
           

           } else {
  
           } 
        },error : (err) => {
  
          console.error("Error in fetching all getRoleList");
        }
      }
    )
    }
    disabled(){
      if(this.tripRequest.tripFor&&this.tripRequest.tripPurpose&&this.tripRequest.tripName&&!this.tripDisabled){
        return false
      }
      return true
    }
    showAddNew:boolean=true
    AddNew(){
      this.showAddNew=true
    }
    addNewClose(){
      this.showAddNew=false

    }
    
    tripResponse:any
    getActiveTripList(){
      this.TripService
      .getActiveTrip(this.tripRequest.userUid)
      .subscribe({
        next : (res:any) => {
          if(res) {
            const data = res
            this.tripResponse=data
            this.showAddNew=false
            // this.tripRequest={
            //   "tripDescription": data?.tripDescription,
            //   "tripName":data?.tripName,
            //   "tripFor": data?.tripFor,
            //   "tripPurpose": data?.tripPurpose,
            //   "userUid": data?.userUid,
            //   "createdBy": data?.createdBy
            // }
           } else {
  
           } 
        },error : (err) => {
  
          console.error("Error in fetching result");
        }
      })}
      approver:any=''
  getUserData(){
    this.userService.getUserData(this.email)
    .subscribe({
      next : (res:any) => {
        if(res) {
   let data:any
   data=res
 this.userInformation=data
  this.getUserByUUid()
        } else {    
        } 
      },error : (err) => {
  
        console.error("Error in fetching data");
      }
    }
  )
  }



  displayedColumns: string[] = ['tripName', 'status', 'tripID', 'action'];
  dataSource = new MatTableDataSource([]);
  ApprovalSource=new MatTableDataSource([]);
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  tripName = '';
  tripID = '';

  

  onSelect() {
    console.log(`Selected Trip: Name=${this.tripName}, ID=${this.tripID}`);
  }

  selectTrip(element: TripData) {
    console.log(`Trip selected: ${element.tripID}`);
  }
 selectActiveTab="employee"
onClick(item:any){
this.selectActiveTab=item
}

  displayedColumn: string[] = [ 'employee', 'trip', 'status', 'actions'];
  tripRequests = [
    {
      date: 'Jun 19–21, 2023',
      employee: 'Ying Liu',
      trip: 'SFO to LAX',
      cost: 113.25,
      status: 'Approved',
    },
    // Repeat or fetch more data here
  ];
  onManageClick(item:any){
    this.activeList(item)
  
    
  }


onViewClick(item:any){
  this.router.navigate(["/app/Trip-Summary/"+item?.tripUid]);

}
 
getUserByUUid(){
 
  this.userService.getUserbyUUid(this.userInformation?.userBookingProfile?.supervisorCodes)
  .subscribe({
    next : (res:any) => {
      if(res) {
        this.approver=res?.name||''

      } else {
      } 
    },error : (err) => {
    }
  }
)


}
}

